import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';

const MessageAlerts = ({ successMessage, errorMessages }) => {
  if (!successMessage && Object.keys(errorMessages).length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      {successMessage && (
        <div className="flex gap-3 p-4 text-green-700 bg-green-50 rounded-md border border-green-200">
          <CheckCircleIcon className="h-5 w-5 flex-shrink-0" />
          <span>{successMessage}</span>
        </div>
      )}

      {Object.keys(errorMessages).length > 0 && (
        <div className="flex gap-3 p-4 text-red-700 bg-red-50 rounded-md border border-red-200">
          <XCircleIcon className="h-5 w-5 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <h3 className="font-semibold mb-2">Please correct the following errors:</h3>
            <div className="space-y-2">
              {Object.entries(errorMessages).map(([field, messages]) => (
                <div key={field}>
                  <div className="font-medium">{field}:</div>
                  <ul className="list-disc ml-5 space-y-1">
                    {messages.map((message, index) => (
                      <li key={index} className="text-sm">
                        {message}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageAlerts;